<template>
    <div class="order-processing-step" @click="clicked" :class="{ 'is-disabled': loading, 'is-completed': step.is_completed }">
        <div class="row align-items-center no-gutters">
            <div class="col col-auto">
                <div class="processing-step-checkbox">
                    <i v-if="loading" class="mdi mdi-spin mdi-loading"></i>
                    <i v-else-if="step.is_completed" class="mdi mdi-check-circle text-success"></i>
                    <i v-else class="mdi mdi-circle-outline status-icon text-gray-500"></i>
                </div>
            </div>
            <div class="col">
                <div class="processing-step-content">
                    <strong class="processing-step-type">{{ step.title }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProcessingStep",

    data: () => ({
        loading: false,
    }),

    methods: {

        clicked () {
            if (this.loading) return;

            if (this.step.is_completed && !window.confirm('Are you sure you want to uncheck this checklist step?')) {
                return;
            }

            this.loading = true;

            const data = {
                steps: [
                    {
                        type: this.step.type,
                        is_completed: !this.step.is_completed
                    }
                ]
            }

            axios.put(`/admin/api/partner/${this.partnerId}/order/${this.orderId}/processing-steps`, data).then(res => {
                if (this.onUpdate) {
                    this.onUpdate({ type: this.step.type, is_completed: !this.step.is_completed});
                }
            }).catch(err => {
                alert('Could not update processing step because of error: ' + err.toString());
            }).finally(() => {
                this.loading = false;
            })
        }
    },

    props: {
        step: {
            type: Object,
            required: true
        },
        orderId: {
            type: String,
            required: true
        },
        partnerId: {
            type: String,
            required: true
        },
        onUpdate: {
            type: Function
        }
    }
};
</script>

<style scoped>

</style>